import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import ListItem from '../components/ListItem';

var ListGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ListGroup, _React$Component);

  function ListGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        selectedId = _this$props.selectedId,
        title = _this$props.title,
        items = _this$props.items;

    if (items.length) {
      return /*#__PURE__*/React.createElement("div", {
        className: "nav-group"
      }, title && /*#__PURE__*/React.createElement("h2", {
        className: "title"
      }, title), /*#__PURE__*/React.createElement("ul", null, items.map(function (item, index) {
        var _item$node = item.node,
            pid = _item$node.pid,
            name = _item$node.name,
            childNodes = _item$node.childNodes;
        return /*#__PURE__*/React.createElement(ListItem, {
          key: "nav-item-" + index,
          selectedId: selectedId,
          pid: pid,
          name: name,
          childNodes: childNodes
        });
      })));
    }

    return null;
  };

  return ListGroup;
}(React.Component);

export default ListGroup;